import DrugActions from './action';

export default {
    state: {
        drug:{},
    },
    mutations: {
        loadDrug(state, payLoad) {
            console.log(payLoad)
            state.drug=payLoad
            var date = new Date(state.drug.registrationDate);
            if (!isNaN(date.getTime())) {
              console.log("mm",date.getMonth())
                // Months use 0 index.
                state.drug.date=  `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
            }
        //    =this.format(payLoad.registartionDate)
        },
    },
    actions: DrugActions,
    getters: {
        getdrug(state) {
            return state.drug;
        },
    },
    modules: {
      
    },
    // format(inputDate) {
    //     var date = new Date(inputDate);
    //     if (!isNaN(date.getTime())) {
    //       console.log("mm",date.getMonth())
    //         // Months use 0 index.
    //         return  `${date.getDate()} /${ date.getMonth()+1} / ${date.getFullYear()}`
    //     }
    // }
   
}